import { useApi } from "../../contexts/ApiContext";

interface RegisterInterestPayload {
  email: string;
  role: string;
  company: string;
  comment?: string;
}

export const useRegisterInterestApi = () => {
  const { post } = useApi();

  const registerInterest = async ({
    email,
    role,
    company,
    comment,
  }: RegisterInterestPayload) => {
    return post(
      "/contact",
      {
        contactType: "interest",
        details: {
          email,
          role,
          company,
          comment,
        },
      },
      { api: "contact", returnResponse: true }
    );
  };

  return { registerInterest };
};